import { Box, IconButton, Paper } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { MoreActionsMenu } from '@/components/shared/components/MoreActionsMenu/MoreActionsMenu';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { SectionTitle } from '@/components/shared/components/SectionTitle';
import { SizedIconWithCircle } from '@/components/shared/components/SizedIconWithCircle';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface HeaderCardProps {
  type: 'merchant' | 'channel';
  title: string;
  iconName: string;
  copyToClipboard: { value: string; textId: string };
  actions?: ActionsOption[];
  redirectPath?: string;
  editModeAllowed?: boolean;
}

export const HeaderCard = ({
  type,
  title,
  iconName,
  copyToClipboard,
  actions,
  redirectPath,
  editModeAllowed = false,
}: HeaderCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  return (
    <Paper elevation={0} style={{ backgroundColor: 'transparent' }}>
      <Box py={'6px'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
        <Box display={'flex'} flexGrow={1} alignItems={'center'}>
          <Box pr={2}>
            <SizedIconWithCircle
              variant={'medium'}
              backgroundColor={palette.secondary.main}
              iconColor={palette.secondary.contrastText}
              customBorderRadius={customBorderRadius.chip}
              iconName={iconName}
              copyToClipboard={copyToClipboard}
            />
          </Box>
          <SectionTitle overline={<Text tId={type} />} title={title} />
        </Box>
        <Box flexShrink={0}>
          {actions && editModeAllowed && (
            <MoreActionsMenu actionsOptionsArray={actions}>
              <IconButton size={'small'} className={'ml-2'}>
                {<i className={'material-icons-outlined'}>more_horiz</i>}
              </IconButton>
            </MoreActionsMenu>
          )}
          {redirectPath && (
            <Link to={redirectPath}>
              <IconButton size={'small'} className={'mx-2'}>
                <i className={'material-icons-outlined'}>chevron_right</i>
              </IconButton>
            </Link>
          )}
        </Box>
      </Box>
    </Paper>
  );
};
